import { render, staticRenderFns } from "./VersionsView.vue?vue&type=template&id=75d654ce&scoped=true&"
import script from "./VersionsView.vue?vue&type=script&lang=js&"
export * from "./VersionsView.vue?vue&type=script&lang=js&"
import style0 from "./VersionsView.vue?vue&type=style&index=0&id=75d654ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d654ce",
  null
  
)

export default component.exports